import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { FaAngleLeft } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserInvestmentDetails } from "../../../redux/actions/adminActions";
import ImgChangeIcon from "../../../assets/images/camera-icon.png";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import ProfilePic from "../../../assets/images/dummy_profile.png";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import Loader from "../../../components/Loader/Loader";
import "react-circular-progressbar/dist/styles.css";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import "../../new/new.scss";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import { CopyToClipboard } from "react-copy-to-clipboard";
import PDF from "../../../assets/images/pdf.svg";
import { saveAs } from "file-saver";
import { useReactToPrint } from "react-to-print";
import { DataGrid } from "@mui/x-data-grid";

// Get ID from URL
const ViewInvestmentUser = (reportId) => {
  let token = localStorage.getItem("accessToken");
  const id = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const userInvestment = useSelector((state) => state.userInvestment);
  const [data, setData] = useState();

  const params = useParams();

  const { user } = userInvestment;
  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 9,
  });

  useEffect(() => {
    fetchUserReferalData();
  }, []);
  const fetchUserReferalData = () => {
    let token = localStorage.getItem("accessToken");
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/get-user-campaign-investment",
      headers: {
        "x-access-token": token,
      },
      data: {
        user_id: params?.reportId,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setPageState((old) => ({
          ...old,
          data: response.data.data,
          total: response.data.data.count,
        }));
        // setReportUrl(response.data.data);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  const userColumns = [
    { field: "id", headerName: " Investment ID", width: 120 },

    {
      field: "Campaign",
      headerName: "Campaign Name",
      width: 300,
    },
    {
      field: "Amount Invested",
      headerName: "Amount Invested",
      width: 300,
    },
    {
      field: "Currency",
      headerName: "Currency",
      width: 200,
    },
    {
      field: "Investment Status",
      headerName: "Investment Status",
      width: 200,
    },
    {
      field: "Date_Time",
      headerName: "Date",
      width: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.Date_Time);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
    {
      field: "Commission Rate",
      headerName: "Commission",
      width: 150,
    },
  ];

  const {
    register,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />

        <div className="datatable">
          <h5 className="h5Title" style={{ textAlign: "center" }}>
            View Investments{" "}
          </h5>
          <div className="datatableTitle"></div>
          <DataGrid
            className="datagrid"
            autoHeight
            rows={pageState.data}
            rowCount={pageState.total}
            rowsPerPageOptions={[10, 30, 50, 70, 100]}
            pagination
            page={pageState.page - 1}
            pageSize={pageState.pageSize}
            paginationMode="server"
            onPageChange={(newPage) => {
              setPageState((old) => ({ ...old, page: newPage + 1 }));
            }}
            onPageSizeChange={(newPageSize) =>
              setPageState((old) => ({ ...old, pageSize: newPageSize }))
            }
            columns={userColumns}
          />
        </div>
      </div>
    </div>
  );
};

export default ViewInvestmentUser;
